import React from "react";

interface InputPlaceholderStylesProps {
  color: string;
}

const selector = "input::placeholder, textarea::placeholder";

/**
 * Component that injects input placeholder style. These styles cannot
 * be applied as inline styles, so they're added as raw CSS in style tags.
 * The !important is required even though our inline styles do not apply
 * these rules.
 */
export const InputPlaceholderStyles: React.FC<InputPlaceholderStylesProps> = ({
  color,
}) => {
  return (
    <style>
      {`
        ${selector} {
          color:${color}!important;
        }
      `}
    </style>
  );
};
